import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass } from '../../style';

export namespace PermissionsLockDialogStyles {
  const permissionsLockDialogCssPrefix = 'PermissionsLockDialog';

  export const StatusIcon = cssClass(permissionsLockDialogCssPrefix, 'lock-status-icon', {
    marginRight: 4,
    verticalAlign: 'text-top',
  });

  export const RadioButtonLabel = cssClass(permissionsLockDialogCssPrefix, 'radio-button-label', {
    fontWeight: 'bold',
    height: `${CommonStyles.Sizes.NormalIconSize}px`,
    lineHeight: `${CommonStyles.Sizes.NormalIconSize}px`,
  });

  export const RadioButtonLabelContainer = cssClass(permissionsLockDialogCssPrefix, 'radio-button-label-container', {
    marginBottom: `${CommonStyles.Sizes.LargeSpace}px`,
  });

  export const PermissionOptionDescription = cssClass(permissionsLockDialogCssPrefix, 'permission-option-description', {
    marginLeft: `${CommonStyles.Sizes.DefaultSpace}px`,
    marginRight: `${CommonStyles.Sizes.LargeSpace}px`,
  });

  export const NestedProjectsOption = cssClass(permissionsLockDialogCssPrefix, 'nested-projects-option', {
    marginTop: `${CommonStyles.Sizes.MediumSpace}px`,
  });

  export const WarningMessageContainer = cssClass(permissionsLockDialogCssPrefix, 'warning-message-container', {
    marginTop: `${CommonStyles.Sizes.MediumSpace}px`,
    overflowWrap: 'anywhere',
  });

  export const ProgressBarContainer = cssClass(permissionsLockDialogCssPrefix, 'progress-bar-container', {
    marginTop: `${CommonStyles.Sizes.LargeSpace}px`,
    marginBottom: `${CommonStyles.Sizes.LargeSpace}px`,
    overflowWrap: 'anywhere',
  });

  export const ProgressBar = cssClass(permissionsLockDialogCssPrefix, 'progress-bar', {
    width: '100%',
  });
}
